const STORAGE_PREFIX = 'foxy.reviewSpoilerAcknowledged.';
const ACKNOWLEDGED_EVENT = 'review-spoiler-acknowledged';

function normalizedReviewId(reviewId) {
    if (reviewId === null || reviewId === undefined || reviewId === '') {
        return null;
    }

    return String(reviewId);
}

export function spoilerAcknowledgementKey(reviewId) {
    const id = normalizedReviewId(reviewId);
    return id === null ? null : `${STORAGE_PREFIX}${id}`;
}

export function isReviewSpoilerAcknowledged(reviewId) {
    const key = spoilerAcknowledgementKey(reviewId);
    if (!key) return false;

    try {
        return window.localStorage.getItem(key) === '1';
    } catch (error) {
        return false;
    }
}

export function acknowledgeReviewSpoiler(reviewId) {
    const id = normalizedReviewId(reviewId);
    const key = spoilerAcknowledgementKey(id);
    if (!key) return;

    try {
        window.localStorage.setItem(key, '1');
    } catch (error) {
        // Storage can be unavailable in private/restricted browser contexts.
    }

    window.dispatchEvent(new CustomEvent(ACKNOWLEDGED_EVENT, {
        detail: { reviewId: id },
    }));
}

export function reviewSpoilerAcknowledgedEvent() {
    return ACKNOWLEDGED_EVENT;
}

export function currentViewerId() {
    const value = document.querySelector('meta[name="user-id"]')?.getAttribute('content');
    return value ? Number(value) : null;
}

export function shouldProtectReviewSpoiler(review, viewerId = null, locallyRevealed = false) {
    if (!review || review.status === 'blocked' || !review.contains_spoiler) {
        return false;
    }

    const isOwner = viewerId !== null
        && Number(review.user_id) === Number(viewerId);

    return !isOwner
        && !Boolean(review.viewer_has_interacted)
        && !locallyRevealed
        && !isReviewSpoilerAcknowledged(review.id);
}

function revealDomReview(reviewId, root = document) {
    const id = normalizedReviewId(reviewId);
    if (id === null) return;

    root.querySelectorAll('[data-review-spoiler]').forEach((container) => {
        if (container.dataset.reviewSpoiler !== id) return;

        const gate = container.querySelector('[data-review-spoiler-gate]');
        const body = container.querySelector('[data-review-spoiler-body]');

        if (gate) {
            gate.hidden = true;
            gate.classList.remove('flex');
            gate.classList.add('hidden');
            gate.setAttribute('aria-hidden', 'true');
        }
        if (body) {
            body.hidden = false;
            body.removeAttribute('hidden');
            body.removeAttribute('aria-hidden');
            body.classList.remove('blur-sm', 'filter', 'select-none', 'pointer-events-none');
        }

        container.dataset.reviewSpoilerAcknowledged = 'true';
    });
}

export function initializeReviewSpoilerProtection(root = document) {
    root.querySelectorAll('[data-review-spoiler]').forEach((container) => {
        const reviewId = container.dataset.reviewSpoiler;
        if (isReviewSpoilerAcknowledged(reviewId)) {
            revealDomReview(reviewId, root);
        }
    });

    root.querySelectorAll('[data-review-spoiler-reveal]').forEach((button) => {
        if (button.dataset.reviewSpoilerBound === 'true') return;

        button.dataset.reviewSpoilerBound = 'true';
        button.addEventListener('click', () => {
            acknowledgeReviewSpoiler(button.dataset.reviewSpoilerReveal);
        });
    });
}

window.addEventListener(ACKNOWLEDGED_EVENT, (event) => {
    revealDomReview(event.detail?.reviewId);
});
